// Import types
import { CalculatedPriceProduct } from 'types/api/packetsSubscription';

// Import helpers
import { convertPriceToReadableFormat, getDurationInMonths } from 'helpers/prices';

export const usePriceInfo = (calculated?: CalculatedPriceProduct) => {
	const currentPrice = convertPriceToReadableFormat(calculated?.current_price);

	const standardPrice = convertPriceToReadableFormat(calculated?.standard_price);

	const isPromotion = Boolean(calculated?.promotion?.id);

	const promotionDuration = getDurationInMonths(calculated?.promotion?.promo_days_period);

	return { isPromotion, standardPrice, currentPrice, promotionDuration };
};
